import React from "react";

import Button from "@busbud/design-system-components/dist/Button";

import type { ErrorModalButtonType } from "@app/helpers/api-error";

import { useStyles } from "./cancel-dialog.styles";

export const BUTTON_TYPES: Record<string, ErrorModalButtonType> = {
  CALL_TO_ACTION: "cta",
  PRIMARY: "primary",
  SECONDARY: "secondary"
} as const;

export type ButtonType = (typeof BUTTON_TYPES)[keyof typeof BUTTON_TYPES];

const COLOR = {
  // @ts-expect-error TS2464 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
  [BUTTON_TYPES.CALL_TO_ACTION]: "accent",
  // @ts-expect-error TS2464 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
  [BUTTON_TYPES.PRIMARY]: "primary",
  // @ts-expect-error TS2464 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
  [BUTTON_TYPES.SECONDARY]: "tertiary"
} as const;

export type ButtonConfig = {
  label: string;
  props?: Object;
  action_name?: ButtonType;
};

type AlertButtonProps = {
  config?: ButtonConfig;
  onClick: (
    button_type: ErrorModalButtonType,
    action_name?: ButtonType
  ) => void;
  type: ErrorModalButtonType;
};

export const AlertButton: React.FC<AlertButtonProps> = props => {
  const { config, onClick, type } = props;
  const { classes } = useStyles();

  if (!config) {
    return null;
  }

  // @ts-expect-error TS7053 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
  const color = COLOR[type];

  return (
    <Button
      {...(config.props || {})}
      color={color}
      className={classes.action_button}
      onClick={() => onClick(type, config.action_name)}
      size="md"
      fullWidth={{
        xs: true,
        md: false
      }}
    >
      {config.label}
    </Button>
  );
};
